import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      position: 'fixed',
      width: '100%',
      zIndex: 200,
    },
    item: {
      width: 'calc(100% - 48px)',
      maxWidth: 890,
    },
  },
  { name: 'SanckbarList' },
);
